import {UilBell, UilMoon, UilQuestionCircle, UilRocket, UilSignOutAlt, UilSun} from "@iconscout/react-unicons";
import {useContext, useState} from "react";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import {Link, useNavigate} from "react-router-dom";
import {ReactComponent as Logo} from "../../assets/newImages/header/logotipo.svg";
import {ReactComponent as TokensIa} from "../../assets/newImages/icons/recursos-ia.svg";
import { ReactComponent as IconUserSVG } from "../../assets/newImages/menuLateral/user.svg";
import { ReactComponent as IconConfigSVG } from "../../assets/newImages/menuLateral/config.svg";
import { ReactComponent as IconAssinaturaSVG } from "../../assets/images/icons/money.svg";
import Ajuda from "../../components/Ajuda/Ajuda";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Modal from "../../components/Modal/Modal";
import Notificacoes from "../../components/Notificacoes/index";
import StepsCriacao from "../../components/StepsCriacao/StepsCriacao";
import FotoUsuario from "../../components/Uteis/FotoUsuario";
import {AuthContext} from "../../contexts/Auth/AuthContext";
import {HeaderContext} from "../../contexts/Header/HeaderContext";
import {useTheme} from "../../contexts/Theme/ThemeContext";
import {PERMISSOES} from "../../services/Consts";
import "./styles";
import {
    MainHeader,
    ModalAjudaContainer,
    ModalTokensIaContainer,
    ModalNotificacoesContainer,
    ModalUsuarioContainer,
} from "./styles";
import {EmpresaContext} from "../../contexts/Empresa/EmpresaContext";
import {AssinaturaContext} from "../../contexts/Assinatura/AssinaturaContext";
import AvisoPagamentoAtrasado from "../../components/AvisoPagamentoAtrasado/AvisoPagamentoAtrasado";
import AvisoTrial from "../../components/AvisoTrial/AvisoTrial";


function Header(props) {
    const {theme, toggleDarkTheme} = useTheme();
    const navigate = useNavigate();
    const [modalMenuUsuario, setModalMenuUsuario] = useState(false);
    const [modalAjuda, setModalAjuda] = useState(false);
    const [modalNotificacoes, setModalNotificacoes] = useState(false);
    const {
        modalTokensIa,
        setModalTokensIa,
        temNotificacaoNova,
        setTemNotificacaoNova,
        tokensDisponiveis
    } = useContext(HeaderContext);
    const {signout, permissoesUsuario, loading, user, permissoesPlanos} = useContext(AuthContext);
    const {empresa} = useContext(EmpresaContext);
    const {fluxoNovo} = useContext(AssinaturaContext);

    const iconeToggleDarkMode = () => {
        return (
            <div className="icone" onClick={() => toggleDarkTheme()}>
                {theme.mode === "light" ? (
                    <>
                        <UilMoon className="botao rotate"></UilMoon>
                        <span className="hideDesktop">Modo Escuro</span>
                    </>
                ) : (
                    <>
                        <UilSun className="botao rotate"></UilSun>
                        <span className="hideDesktop">Modo Claro</span>
                    </>
                )}
            </div>
        );
    };

    const iconeSignOut = () => {
        return (
            <div className="icone" onClick={() => signout()}>
                <UilSignOutAlt className="botao"></UilSignOutAlt>
                <span className="hideDesktop">Sair da conta</span>
            </div>
        );
    };

    const iconePerfil = () => {
        return (
            <Link
                to={"/perfil/usuarios"}
                onClick={() => setModalMenuUsuario(false)}
            >
                <IconUserSVG className="icon-perfil" />
                <span>Usuários</span>
            </Link>
        );
    };

    const iconeAssinatura = () => {
        if (fluxoNovo !== true) return null;
        return (
            <Link
                to={"/assinatura"}
                onClick={() => setModalMenuUsuario(false)}
            >
                <IconAssinaturaSVG className="icon-perfil" />
                <span>Assinatura</span>
            </Link>
        );
    };

    const iconeConfiguracoes = () => {
        return (
            <Link
                to={"/painel/configuracoes"}
                onClick={() => setModalMenuUsuario(false)}
            >
                <IconConfigSVG className="icon-perfil" />
                <span>Configurações</span>
            </Link>
        );
    };

    const logo = () => {
        return (
            <Link
                className="logoHorizontal hideDesktop"
                to={"/"}
                style={{textDecoration: "none"}}
            >
                <Logo/>
            </Link>
        );
    };

    const tokensIa = () => {
        return (
            <button
                className="botaoTokensIa fonteTexto"
                onClick={() => setModalTokensIa(!modalTokensIa)}
            >
                <TokensIa className="tokens-ia"></TokensIa>
                <div className="fonteRotulos">
                    <span className="hideMobile">{(tokensDisponiveis || 0).toLocaleString("pt-BR")} tokens</span>
                    <span className="hideDesktop"> {(tokensDisponiveis || 0).toLocaleString("pt-BR")} tks</span>
                </div>
            </button>
        );
    };

    const notificacao = () => {
        return (
            <div className={temNotificacaoNova ? "blink" : ""}>
                <UilBell
                    className={temNotificacaoNova ? "botao ringBell" : "botao"}
                    onClick={() => {
                        setModalNotificacoes(true)
                        setTemNotificacaoNova(false);
                    }}
                ></UilBell>
            </div>
        );
    };

    const duvidas = () => {
        return (
            <div>
                <UilQuestionCircle
                    onClick={() => setModalAjuda(!modalAjuda)}
                    className="botao"
                ></UilQuestionCircle>
            </div>
        );
    };

    const breadCrumbs = () => {
        return <Breadcrumbs></Breadcrumbs>;
    };

    return (
        <>

            {(permissoesUsuario.includes(PERMISSOES.USUARIOS_GERENTE) && empresa?.pagamento_em_atraso && fluxoNovo !== true) && (
                <AvisoPagamentoAtrasado
                    tipoPagamento={(empresa?.forma_pagamento as "1" | "2") || "1"}
                />
            )}
            {(permissoesUsuario.includes(PERMISSOES.USUARIOS_GERENTE)) && (
                <AvisoTrial/>
            )}
            <Modal
                isOpen={modalMenuUsuario}
                setModal={setModalMenuUsuario}
                width={"auto"}
                hideDesktop={true}
                align={"flex-end"}
                justify="flex-start"
                animation="comeFromTop 600ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 0rem"
                borderRadius="30px"
            >
                <ModalUsuarioContainer theme={theme}>
                    <div className="modal-container">
                        <div className="icones-container">
                            <div className="icone-container configs-perfil">
                                <div className="icone fonteTexto">{iconePerfil()}</div>
                                <div className="icone fonteTexto">{iconeAssinatura()}</div>
                                <div className="icone fonteTexto">{iconeConfiguracoes()}</div>
                            </div>
                            <div className="icone-container fonteTexto">
                                {iconeToggleDarkMode()}
                            </div>
                            <div className="icone-container fonteTexto">
                                {iconeSignOut()}
                            </div>
                        </div>
                    </div>
                </ModalUsuarioContainer>
            </Modal>
            <Modal
                isOpen={modalTokensIa}
                setModal={setModalTokensIa}
                width={"390px"}
                align={"flex-end"}
                justify="flex-start"
                animation="comeFromTop 600ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
                borderRadius="30px"
            >
                <ModalTokensIaContainer theme={theme}>
                    <div className="modal-tokens-ia">
                        <div className="header-modal-tokens">
                            <div className="titulo fonteTitulo">Tokens</div>
                            <div className="subtitulo-criacao fonteRotulos">
                                Tokens funcionam como créditos para usar nos recursos de inteligência artificial no
                                Conecta Venda.
                                Eles dão acesso a funcionalidades especiais da sua conta, são renovados todo mês e não
                                acumulam.
                            </div>
                        </div>
                        <div className="quantidade-tokens">
                            <TokensIa className="tokens-ia"></TokensIa>
                            <p className="texto-quantidade-tokens fonteRotulos">Você
                                tem {(tokensDisponiveis || 0).toLocaleString("pt-BR")} tokens disponíveis para uso</p>
                        </div>
                    </div>
                </ModalTokensIaContainer>
            </Modal>
            <Modal
                isOpen={modalAjuda}
                setModal={setModalAjuda}
                width={"auto"}
                align={"flex-end"}
                justify="flex-start"
                animation="comeFromTop 600ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
                borderRadius="30px"
            >
                <ModalAjudaContainer theme={theme}>
                    <Ajuda onClose={() => setModalAjuda(false)}/>
                </ModalAjudaContainer>
            </Modal>
            <Modal
                isOpen={modalNotificacoes}
                setModal={setModalNotificacoes}
                width={"auto"}
                align={"flex-end"}
                justify="flex-start"
                animation="comeFromTop 600ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem"
                borderRadius="30px"
            >
                <ModalNotificacoesContainer theme={theme}>
                    <Notificacoes onClose={() => setModalNotificacoes(false)}/>
                </ModalNotificacoesContainer>
            </Modal>
            <MainHeader theme={theme}>
                <div className="headerContainer">
                    {logo()}
                    <div className="paginacaoContainer fonteSubtitulo hideMobile">
                        {breadCrumbs()}
                    </div>
                    <div className="headerEfeito"></div>
                    <div className="botoesContainer">
                        {/* {permissoesUsuario.includes(PERMISSOES.CONFIGURACOES) && (
                            <div className="botaoGuia">{botaoGuia()}</div>
                        )} */}
                        <div className="icone">{tokensIa()}</div>
                        <div className="icone">{notificacao()}</div>
                        <div className="icone">{duvidas()}</div>
                        <div className="icone hideMobile">
                            {iconeToggleDarkMode()}
                        </div>
                        <div className="icone hideMobile">{iconeSignOut()}</div>
                        <div className="icone hideDesktop">
                            <FotoUsuario
                                onClick={() => {
                                    setModalMenuUsuario(true);
                                }}
                                className="foto"
                                size={5}
                            ></FotoUsuario>
                        </div>
                    </div>
                </div>
                <div className="paginacaoContainerMobile hideDesktop">
                    {breadCrumbs()}
                </div>
            </MainHeader>
        </>
    );
}

export default Header;
